// extracted by mini-css-extract-plugin
export default {"header":"hVMct","title":"kNkHq","arrow":"FQSgE","divider":"_2j1ol","details":"NsO07","checkbox":"Ab8DV","form":"zonOe","editable":"T++yU","expanded":"_4wl4J","filled":"XsqXn"};